module.exports = __webpack_public_path__ + "media/video.d6c76382.mp4";